import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ThumbExistingBucket from '../../quotes/entities/thumbExistingBucket';
import {
  TextMosaic,
  TextMosaicDto,
  ImageMosaic,
  ImageMosaicDto,
  MosaicWall,
} from '@ami/react/core';
import { Button, Input } from 'reactstrap';
import thumbBucketProfileService from '../../thumb-bucket-profiles/thumbBucketProfileService';
import ThumbBucketProfileFilter from '../../thumb-bucket-profiles/ThumbBucketProfileFilter';
import { Quote } from '../../quotes/quote';
import { FormFileUpload } from '@ami/react/core';
import BucketBrandType from '../../quotes/entities/bucketBrandType';
import { ThumbBucketProfileToothStyleType } from '../../quotes/entities/thumbBucketProfileToothStyleType';
import { ThumbBucketProfileStyleType } from '../../thumb-bucket-profiles/ThumbBucketProfileStyleType';
import _ from 'lodash';
import { makeConcealable } from '@ami/react/core';

const DivWhatIsTheBucketWidth = makeConcealable((props) => (
  <div className="row justify-content-center text-center mb-2">
    <h5>What is the bucket width?</h5>
  </div>
));
const DivWhatIsTheBucketCapacity = makeConcealable((props) => (
  <div className="row justify-content-center text-center mb-2">
    <h5>What is the bucket capacity?</h5>
  </div>
));
const DivWhatIsTheBucketBrand = makeConcealable((props) => (
  <div className="row justify-content-center text-center mb-2">
    <h5>What is the bucket brand?</h5>
  </div>
));
const DivHowManyTeeth = makeConcealable((props) => (
  <div className="row justify-content-center text-center mb-2">
    <h5>How many teeth?</h5>
  </div>
));
const DivWhatStyleOfTooth = makeConcealable((props) => (
  <div className="row justify-content-center text-center mb-2">
    <h5>What style of tooth?</h5>
  </div>
));
const DivPhotos = makeConcealable((props) => (
  <div className="row justify-content-center text-center mb-2">
    <h5>Photos</h5>
  </div>
));

class ProductExistingBucketDetailComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(ThumbExistingBucket).isRequired,
    onUpdate: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote).isRequired,
    onChangeBucketDetails: PropTypes.func.isRequired,
    onFinishBucketConfiguration: PropTypes.func.isRequired,
  };

  state = {
    thumbBucketProfiles: [],
    thumbBucketProfileId: null,
    bucketStyle: null,
    width: null,
    capacityUnits: null,
    capacityUnitsName: '',
    minimumCapacity: null,
    maximumCapacity: null,
    overallTipRadius: null,
    thumbBucketProfileView: null,
    brand: null,
    otherBrandName: '',
    amiSerialNumber: '',
    toothCount: null,
    toothStyle: null,
    photos: [],
    toothStyles: [],
  };

  async componentDidMount() {
    const { quote, entity } = this.props;

    this.setState({
      bucketStyle: entity.bucketStyle,
      width: entity.width,
      capacityUnits: entity.capacityUnits,
      capacityUnitsName: entity.capacityUnitsName,
      minimumCapacity: entity.minimumCapacity,
      maximumCapacity: entity.maximumCapacity,
      overallTipRadius: entity.overallTipRadius,
      brand: entity.brand,
      otherBrandName: entity.otherBrandName,
      amiSerialNumber: entity.amiSerialNumber,
      toothCount: entity.toothCount,
      toothStyle: entity.toothStyle,
      photos: entity.photos,
      thumbBucketProfileId: entity.thumbBucketProfileId,
    });

    await thumbBucketProfileService
      .search(
        new ThumbBucketProfileFilter({
          carrierId: quote.step1.carrierId,
          weightCategoryId: quote.step1.weightCategoryId,
        })
      )
      .then((thumbBucketProfiles) => {
        this.setState({ thumbBucketProfiles }, () => {
          this.getthumbBucketProfileView();
        });
      });

    await thumbBucketProfileService.getToothStyleType().then((toothStyles) => {
      this.setState({ toothStyles });
    });
  }

  componentDidUpdate(prevProps) {
    const { entity } = this.props;
    if (prevProps.entity !== this.props.entity) {
      this.setState(
        {
          bucketStyle: entity.bucketStyle,
          width: entity.width,
          capacityUnits: entity.capacityUnits,
          capacityUnitsName: entity.capacityUnitsName,
          minimumCapacity: entity.minimumCapacity,
          maximumCapacity: entity.maximumCapacity,
          overallTipRadius: entity.overallTipRadius,
          brand: entity.brand,
          otherBrandName: entity.otherBrandName,
          amiSerialNumber: entity.amiSerialNumber,
          toothCount: entity.toothCount,
          toothStyle: entity.toothStyle,
          photos: entity.photos,
          thumbBucketProfileId: entity.thumbBucketProfileId,
        },
        () => {
          this.getthumbBucketProfileView();
        }
      );
    }
  }

  onContinue() {
    const { entity, onUpdate, onChangeBucketDetails, onFinishBucketConfiguration } = this.props;

    entity.thumbBucketProfileId = this.state.thumbBucketProfileId;
    entity.bucketStyle = this.state.bucketStyle;
    entity.width = this.state.width;
    entity.capacityUnits = this.state.capacityUnits;
    entity.capacityUnitsName = this.state.capacityUnitsName;
    entity.minimumCapacity = this.state.minimumCapacity;
    entity.maximumCapacity = this.state.maximumCapacity;
    entity.overallTipRadius = this.state.overallTipRadius;
    entity.brand = this.state.brand;
    entity.otherBrandName = this.state.otherBrandName;
    entity.amiSerialNumber = this.state.amiSerialNumber;
    entity.toothCount = this.state.toothCount;
    entity.toothStyle = this.state.toothStyle;
    entity.photos = this.state.photos;

    onUpdate(new ThumbExistingBucket({ ...entity }));
    onChangeBucketDetails(false);
    onFinishBucketConfiguration(true);
  }

  getBucketStyles() {
    const { thumbBucketProfiles } = this.state;

    const bucketStyles = [];
    const map = new Map();
    for (const item of thumbBucketProfiles) {
      if (!map.has(item.style)) {
        map.set(item.style, true);
        bucketStyles.push({
          id: item.style,
          name: item.styleName,
        });
      }
    }

    return bucketStyles;
  }

  getBucketWidth() {
    const { thumbBucketProfiles, bucketStyle } = this.state;

    const thumbBucketProfilesFiltered = thumbBucketProfiles.filter(
      (x) => x.style === bucketStyle
    );
    const bucketWidth = [];
    const map = new Map();
    for (const item of thumbBucketProfilesFiltered) {
      if (!map.has(item.width)) {
        map.set(item.width, true);
        bucketWidth.push({
          id: item.width,
          name: item.width,
        });
      }
    }
    return bucketWidth;
  }

  onChangebucketStyle(bucketStyle) {
    this.setState({
      bucketStyle,
      width: null,
      capacityUnits: null,
      capacityUnitsName: '',
      minimumCapacity: null,
      maximumCapacity: null,
      overallTipRadius: null,
      brand: null,
      otherBrandName: '',
      amiSerialNumber: '',
      toothCount: null,
      toothStyle: null,
      photos: [],
      thumbBucketProfileId: null,
      thumbBucketProfileView: null,
    });
  }

  onChangeWidth(width) {
    this.setState(
      {
        width,
        capacityUnits: null,
        capacityUnitsName: '',
        minimumCapacity: null,
        maximumCapacity: null,
        overallTipRadius: null,
        brand: null,
        otherBrandName: '',
        amiSerialNumber: '',
        toothCount: null,
        toothStyle: null,
        photos: [],
        thumbBucketProfileId: null,
        thumbBucketProfileView: null,
      },
      () => {
        this.getthumbBucketProfileView();
      }
    );
  }

  onChangeBrand(brand) {
    this.setState(
      {
        brand,
        otherBrandName: '',
        amiSerialNumber: '',
        toothCount: null,
        toothStyle: null,
      },
      () => {
        this.getthumbBucketProfileView();
      }
    );
  }

  async getthumbBucketProfileView() {
    const { thumbBucketProfiles, bucketStyle, width } = this.state;

    if (!!bucketStyle && !!width) {
      const thumbBucketProfile = thumbBucketProfiles.find(
        (x) => x.style === bucketStyle && x.width === width
      );
      var thumbBucketProfileView = await thumbBucketProfileService.getView(
        thumbBucketProfile.id
      );
      this.setState({
        thumbBucketProfileView,
        thumbBucketProfileId: thumbBucketProfile.id,
        capacityUnits: thumbBucketProfileView.capacityUnits,
        capacityUnitsName: thumbBucketProfileView.capacityUnitsName,
      });
    }
  }

  addPhoto(photo) {
    const { photos } = this.state;
    photos.push(photo);
    this.setState({ photos });
  }

  removePhoto(photo) {
    const { photos } = this.state;
    this.setState({ photos: photos.filter((x) => x != photo) });
  }

  getToothConfigurations() {
    const { thumbBucketProfileView } = this.state;
    const a = _.uniqBy(
      thumbBucketProfileView.toothConfigurations,
      (x) => x.toothCount
    );
    return a.sort((a, b) => {
      return a.toothCount < b.toothCount ? -1 : 1;
    });
  }

  getToothStyles = () => {
    const { toothStyle, toothCount, thumbBucketProfileView, toothStyles } =
      this.state;
    const toothConfigurationsFiltered =
      thumbBucketProfileView.toothConfigurations.filter(
        (x) => x.toothCount === toothCount
      );
    var ThumbBucketProfileToothStyleTypeOptions = [];

    if (
      toothConfigurationsFiltered.some(
        (x) => x.toothStyle === ThumbBucketProfileToothStyleType.Standard
      )
    ) {
      const item = toothStyles.find(
        (x) => x.id === ThumbBucketProfileToothStyleType.Standard
      );
      if (item) {
        ThumbBucketProfileToothStyleTypeOptions.push(
          new ImageMosaicDto({
            id: item.id,
            label: item.label,
            imageUrl: item.imageUrl,
            selected: item.id === toothStyle,
            padding: 'p-3',
          })
        );
      }
    }

    if (
      toothConfigurationsFiltered.some(
        (x) => x.toothStyle === ThumbBucketProfileToothStyleType.Flare
      )
    ) {
      const item = toothStyles.find(
        (x) => x.id === ThumbBucketProfileToothStyleType.Flare
      );
      if (item) {
        ThumbBucketProfileToothStyleTypeOptions.push(
          new ImageMosaicDto({
            id: item.id,
            label: item.label,
            imageUrl: item.imageUrl,
            selected: item.id === toothStyle,
            padding: 'p-3',
          })
        );
      }
    }

    return ThumbBucketProfileToothStyleTypeOptions;
  };

  getCapacityConfigurations() {
    const { thumbBucketProfileView } = this.state;
    const { capacityConfigurations } = thumbBucketProfileView;

    var itemsOrdered = capacityConfigurations.sort((a, b) => {
      if (a.maximumCapacity === null) {
        return 1;
      }

      if (b.maximumCapacity === null) {
        return -1;
      }

      if (a.maximumCapacity === b.maximumCapacity) {
        return 0;
      }

      return a.maximumCapacity < b.maximumCapacity ? -1 : 1;
    });

    itemsOrdered.forEach(function (item, index) {
      if (index > 0) {
        item.minimumCapacity = itemsOrdered[index - 1].maximumCapacity;
      } else {
        item.minimumCapacity = null;
      }
    });

    return itemsOrdered;
  }

  render() {
    const {
      bucketStyle,
      width,
      minimumCapacity,
      maximumCapacity,
      overallTipRadius,
      thumbBucketProfileView,
      brand,
      amiSerialNumber,
      toothCount,
      toothStyle,
      photos,
      otherBrandName,
    } = this.state;
    const bucketStyles = this.getBucketStyles();

    return (
      <Fragment>
        <div className="row justify-content-center text-center mb-2">
          <h5>What is the bucket style?</h5>
        </div>
        <div className="row text-center mt-1">
          <MosaicWall
            childrenContainerClassName="row justify-content-center"
            placeholder="Select a option.."
          >
            {bucketStyles.map((item, i) => (
              <TextMosaic
                key={i}
                data={
                  new TextMosaicDto({
                    label: <div>{item.name}</div>,
                    selected: item.id === bucketStyle,
                  })
                }
                onClick={() => this.onChangebucketStyle(item.id)}
                widthColumns={4}
              />
            ))}
          </MosaicWall>
        </div>
        <DivWhatIsTheBucketWidth scrollOnShow={true} show={!!bucketStyle} />
        {bucketStyle && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              {this.getBucketWidth().map((item, i) => (
                <TextMosaic
                  key={i}
                  data={
                    new TextMosaicDto({
                      label: <div>{item.name}"</div>,
                      selected: item.id === width,
                    })
                  }
                  onClick={() => this.onChangeWidth(item.id)}
                  widthColumns={4}
                />
              ))}
            </MosaicWall>
          </div>
        )}
        <DivWhatIsTheBucketCapacity
          scrollOnShow={true}
          show={thumbBucketProfileView !== null}
        />
        {thumbBucketProfileView && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              {this.getCapacityConfigurations().map((item, i) => (
                <TextMosaic
                  key={i}
                  data={
                    new TextMosaicDto({
                      label: item.getBucketForDisplay(
                        thumbBucketProfileView.capacityUnitsName
                      ),
                      description: (
                        <div>Overall tip radius {item.tipRadius}"</div>
                      ),
                      selected:
                        item.minimumCapacity === minimumCapacity &&
                        item.maximumCapacity === maximumCapacity &&
                        item.tipRadius === overallTipRadius,
                    })
                  }
                  onClick={() =>
                    this.setState({
                      minimumCapacity: item.minimumCapacity,
                      maximumCapacity: item.maximumCapacity,
                      overallTipRadius: item.tipRadius,
                    })
                  }
                />
              ))}
            </MosaicWall>
          </div>
        )}
        <DivWhatIsTheBucketBrand
          scrollOnShow={true}
          show={!!overallTipRadius}
        />
        {!!overallTipRadius && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>{BucketBrandType.ami.label}</div>,
                    selected: brand === BucketBrandType.ami.id,
                  })
                }
                onClick={() => this.onChangeBrand(BucketBrandType.ami.id)}
                widthColumns={4}
              />
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>{BucketBrandType.other.label}</div>,
                    selected: brand === BucketBrandType.other.id,
                  })
                }
                onClick={() => this.onChangeBrand(BucketBrandType.other.id)}
                widthColumns={4}
              />
            </MosaicWall>
            {brand && brand === BucketBrandType.ami.id && (
              <div className="col-6 offset-3 mb-2">
                <Input
                  placeholder="Enter the AMI serial #"
                  value={amiSerialNumber}
                  onChange={(e) =>
                    this.setState({ amiSerialNumber: e.target.value })
                  }
                />
              </div>
            )}
            {brand && brand === BucketBrandType.other.id && (
              <div className="col-6 offset-3 mb-2">
                <Input
                  placeholder="Enter the brand"
                  value={otherBrandName}
                  onChange={(e) =>
                    this.setState({ otherBrandName: e.target.value })
                  }
                />
              </div>
            )}
            {brand && brand === BucketBrandType.other.id && (
              <div className="col-6 offset-3 mb-2">
                <Input
                  placeholder="Enter the part number"
                  value={amiSerialNumber}
                  onChange={(e) =>
                    this.setState({ amiSerialNumber: e.target.value })
                  }
                />
              </div>
            )}
          </div>
        )}
        <DivHowManyTeeth
          scrollOnShow={true}
          show={
            brand != null &&
            bucketStyle !== null &&
            bucketStyle === ThumbBucketProfileStyleType.Digging &&
            thumbBucketProfileView !== null
          }
        />
        {brand &&
          bucketStyle === ThumbBucketProfileStyleType.Digging &&
          thumbBucketProfileView && (
            <div className="row text-center mt-1">
              <MosaicWall
                childrenContainerClassName="row justify-content-center"
                placeholder="Select a option.."
              >
                {this.getToothConfigurations().map((item, i) => (
                  <TextMosaic
                    key={i}
                    data={
                      new TextMosaicDto({
                        label: <div>{item.toothCount}</div>,
                        selected: item.toothCount === toothCount,
                      })
                    }
                    onClick={() =>
                      this.setState({ toothCount: item.toothCount })
                    }
                    widthColumns={4}
                  />
                ))}
              </MosaicWall>
            </div>
          )}
        <DivWhatStyleOfTooth
          scrollOnShow={true}
          show={
            brand !== null &&
            toothCount !== null &&
            thumbBucketProfileView !== null
          }
        />
        {brand && toothCount && thumbBucketProfileView && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              {this.getToothStyles().map((x) => (
                <ImageMosaic
                  key={x.id}
                  data={x}
                  mdWidthColumns={2}
                  onClick={(toothStyle) => this.setState({ toothStyle })}
                />
              ))}
            </MosaicWall>
          </div>
        )}
        <DivPhotos
          scrollOnShow={true}
          show={
            brand !== null &&
            bucketStyle !== null &&
            (bucketStyle !== ThumbBucketProfileStyleType.Digging ||
              (bucketStyle === ThumbBucketProfileStyleType.Digging &&
                !!toothStyle))
          }
        />
        {brand &&
          (bucketStyle !== ThumbBucketProfileStyleType.Digging ||
            (bucketStyle === ThumbBucketProfileStyleType.Digging &&
              toothStyle)) && (
            <div className="row justify-content-center from-sub-heading">
              Attaching photos of your bucket and/or coupler helps to ensure a
              proper fit
            </div>
          )}
        {brand &&
          (bucketStyle !== ThumbBucketProfileStyleType.Digging ||
            (bucketStyle === ThumbBucketProfileStyleType.Digging &&
              toothStyle)) &&
          photos.map((item, i) => (
            <li className="list-group-item document-item" key={i}>
              <div className="flextable">
                <div className="flextable-item flextable-primary">
                  <div className="text-break-line">
                    {item.imageName ? item.imageName : item.imageKey}&nbsp;
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => {
                        this.removePhoto(item);
                      }}
                    >
                      x
                    </button>
                  </div>
                </div>
              </div>
            </li>
          ))}
        {brand &&
          (bucketStyle !== ThumbBucketProfileStyleType.Digging ||
            (bucketStyle === ThumbBucketProfileStyleType.Digging &&
              toothStyle)) && (
            <div className="row justify-content-center text-center mb-2">
              <div className="col-6 offset-md-3 mb-2">
                <FormFileUpload
                  onFileUploaded={(fileInfo) =>
                    this.addPhoto({
                      imageKey: fileInfo.key,
                      imageName: fileInfo.name,
                      imageUrl: fileInfo.url,
                    })
                  }
                  acceptedFileTypes="image/*"
                  uploadDescription={'Drag photos here, or click to select'}
                />
              </div>
            </div>
          )}
        {brand &&
          (bucketStyle !== ThumbBucketProfileStyleType.Digging ||
            (bucketStyle === ThumbBucketProfileStyleType.Digging &&
              toothStyle)) && (
            <div className="row justify-content-center text-center mb-2">
              <Button
                color="success"
                className="m-1"
                onClick={() => this.onContinue()}
              >
                Continue
              </Button>
            </div>
          )}
      </Fragment>
    );
  }
}

export default makeConcealable(ProductExistingBucketDetailComponent);
